export const DAY = 'day';
export const DAY3 = 'day3';
export const WEEK = 'week';
export const MONTH = 'month';
export const MONTH3 = 'month3';
export const MONTH6 = 'month6';
